var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"pagination":false,"columns":_vm.columns,"size":"middle","data-source":_vm.sourceData,"row-key":"id"},scopedSlots:_vm._u([{key:"user",fn:function(record){return [_vm._v(_vm._s(record.nickname))]}},{key:"description",fn:function(record){return _c('span',{staticClass:"description"},[_vm._v(_vm._s(record))])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }